export type WhatsAppTemplateType = 'ORDER_CONFIRMATION' | 'INVOICE' | 'STATUS_UPDATE';

export interface WhatsAppTemplate {
  id: number;
  name: string;
  type: WhatsAppTemplateType;
  body: string;
  active: boolean;
  createdOn?: string;
  modifiedOn?: string;
}

export interface WhatsAppTemplateFormData {
  name: string;
  type: WhatsAppTemplateType;
  body: string;
  active: boolean;
}

export interface WhatsAppTemplateRequest {
  name: string;
  type: WhatsAppTemplateType;
  body: string;
  active: boolean;
}

export const emptyWhatsAppTemplateFormData: WhatsAppTemplateFormData = {
  name: '',
  type: 'ORDER_CONFIRMATION',
  body: '',
  active: true,
};

export const mapWhatsAppTemplateToFormData = (template?: WhatsAppTemplate): WhatsAppTemplateFormData => ({
  name: template?.name ?? '',
  type: template?.type ?? 'ORDER_CONFIRMATION',
  body: template?.body ?? '',
  active: template?.active ?? true,
});

/** Placeholder tokens available per template type, must match EmailPlaceholderRenderer on the backend. */
export const WHATSAPP_TEMPLATE_PLACEHOLDERS: Record<WhatsAppTemplateType, string[]> = {
  ORDER_CONFIRMATION: [
    'customerName',
    'customerEmail',
    'customerPhone',
    'companyName',
    'reservationNumber',
    'vehicle',
    'licensePlate',
    'startDate',
    'endDate',
    'pickupTime',
    'returnTime',
    'pickupLocation',
    'returnLocation',
    'totalDays',
    'totalAmount',
    'currency',
  ],
  INVOICE: [
    'customerName',
    'customerEmail',
    'customerPhone',
    'companyName',
    'invoiceNumber',
    'invoiceDate',
    'dueDate',
    'vehicle',
    'startDate',
    'endDate',
    'pickupLocation',
    'returnLocation',
    'totalAmount',
    'balanceDue',
    'amountPaid',
    'currency',
  ],
  STATUS_UPDATE: [
    'customerName',
    'customerEmail',
    'customerPhone',
    'companyName',
    'reservationNumber',
    'vehicle',
    'licensePlate',
    'startDate',
    'endDate',
    'pickupTime',
    'returnTime',
    'pickupLocation',
    'returnLocation',
    'totalDays',
    'totalAmount',
    'currency',
    'previousStatus',
    'newStatus',
    'statusChangeReason',
  ],
};

export interface WhatsAppPreview {
  templateId: number;
  recipientPhone: string;
  body: string;
}
